import React, { Component } from "react";
import ChannelBox from "./ChannelBox";
import ChatStartButton from "./ChatStartButton";
import ContactFormButton from "./ContactFormButton";
import InitialChannelHeader from "./InitialChannelHeader";
import searchImage from "../../images/search.svg";
import servicesImage from "../../images/product-services.svg";
import Collapse from "@material-ui/core/Collapse";
import { s360ConfigService } from "../Services/S360Config";

import "./InitialFormStyleSheet.css";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
const MAX_ITEMS = 3;
class InitialChannelFormDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false, windowHeight: window.innerHeight };

    this.items =
      this.props.config &&
      this.props.config.configDetails &&
      !this.props.config.configDetails.offline &&
      this.props.config.channels
        ? this.props.config.channels.sort((i1, i2) => {
            return i1.selposition - i2.selposition;
          })
        : [];
    const ref = React.createRef();

    this.components = this.items.map((item) => {
      if (!item.chatButton && !item.submitButton) {
        return {
          item,
          ref,
          component: (
            <ChannelBox ref={ref} item={item} key={item.selposition} />
          ),
        };
      } else if (!item.chatButton && item.submitButton) {
        return {
          item,
          ref,
          component: (
            <ContactFormButton
              handleContactForm={this.props.handleContactForm}
              ref={ref}
              item={item}
              key={item.selposition}
            />
          ),
        };
      } else {
        return {
          item,
          ref,
          component: (
            <ChatStartButton
              handleRedirect={this.props.handleRedirect}
              ref={ref}
              item={item}
              key={item.selposition}
            />
          ),
        };
      }
    });
  }
  handleRedirect = () => {
    s360ConfigService?.config?.configDetails?.skipForm
      ? this.props.moveToConversationPage()
      : this.props.handleRedirect();
  };

  containerStyle = () => {
    return {
      // backgroundColor: this.props.config.designDetails.pageBackgroundColor
      boxShadow: this.props.config.configDetails.hideFAQ
        ? "#FFFFFF"
        : "-3px 32px 17px 1px rgba(0,0,0,0.05)",
    };
  };

  allConversationStyle = () => {
    return {
      fontFamily: this.props.config.designDetails.convHeaderFont,
      fontSize: this.props.config.designDetails.convHeaderFontSize + "px",
      color: this.props.config.designDetails.convHeaderMessageFontColor,
    };
  };

  buttonStyle = () => {
    return {
      background: this.props.config.designDetails.formButtonBackground,
      color: this.props.config.designDetails.formButtonColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
    };
  };

  startChat = () => {
    // TODO: Add validations for fields.

    let invalidOptions = this.components.filter((component) => {
      return !component.ref.current.validate();
    });
    const isValid = invalidOptions.length === 0;
    if (isValid) {
      let params = {};
      this.components.forEach(
        (component) =>
          (params = { ...params, ...component.ref.current.value() })
      );
      this.props.actions.startChat(params);
    } else if (invalidOptions.length > 0) {
      let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
      this.props.actions.showPopUpMessage(errorMessage);
      invalidOptions[0].ref.current.focus = true;
    }
  };

  render() {
    // Sort form items by selposition.
    return (
      <>
        <InitialChannelHeader {...this.props} />
        <div
          style={{
            height: "100%",
            width: "100%",
            background: "#fff",
            maxHeight: "107%",
          }}
        >
          <div
            style={{
              height: "313px",
              overflowY: "hidden",
              width: "100%",
              maxHeight: "90%",
              "border-radius": "20px",
            }}
          >
            <div
              className="s360-initial-channel-container"
              style={this.containerStyle()}
            >
              <div
                className="s360-initial-channel-list"
                style={this.allConversationStyle()}
              >
                {(!this.props.config.configDetails.offline &&
                  this.props.config.configDetails.channelIntroText) ||
                  (this.props.config.configDetails.offline &&
                    this.props.config.configDetails.offlineIntroText)}
              </div>
              <div className="s360-initial-channel-list-item">
                <Collapse
                  in={this.state.show}
                  style={{
                    minHeight: this.props.config.configDetails.hideFAQ
                      ? 237
                      : 150,
                    visibility: "unset",
                    transitionDuration: "200ms",
                  }}
                >
                  <div>
                    <span>
                      {this.components.map((component) => (
                        <>{component.component}</>
                      ))}
                    </span>
                  </div>
                </Collapse>
              </div>

              {this.components.length > 5 && (
                <div className="s360-initial-channel-list-items">
                  <a
                    onClick={() => this.setState({ show: !this.state.show })}
                    style={{ textDecoration: "none", cursor: "pointer" }}
                  >
                    {this.state.show ? "View less" : "View more"}
                  </a>
                </div>
              )}
            </div>

            {!this.props.config.configDetails.hideFAQ && (
              <div
                className="s360-initial-channel-faq-container"
                style={this.containerStyle()}
              >
                <div
                  className="s360-initial-channel-faq-list"
                  style={this.allConversationStyle()}
                >
                  {/* <h5 className="s360-initial-channel-h5">FAQ</h5> */}
                  <div className="s360-initial-channel-faq-list-item"> FAQ</div>
                  <div className="s360-initial-channel-faq-list-img">
                    <img
                      style={{
                        width: "20px",
                        height: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      src={searchImage}
                      alt="/"
                    ></img>
                  </div>
                </div>
                <div className="s360-initial-channel-faq-list-item">
                  <div>
                    <span>
                      {/* <div className="s360-initial-channel-list-item-img">
                               <img style={{ width: "20px", height: "20px", marginTop: "10px", marginBottom: "14px", marginRight:"16px" ,cursor: "pointer" }} src={servicesImage}  alt="/"></img>
                               <div className="s360-initial-channel-list-item-text">Product &amp; Services</div>
                              </div> */}

                      <a
                        href=""
                        class="styles_channel__396ZG styles_whatsapp__80fGh"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          paddingBottom: "14px",
                          width: "100%",
                          marginBottom: "3%",
                          marginLeft: "-16px",
                          paddingLeft: "25px",
                        }}
                      >
                        <div class="styles_channelIcon__1i0qs styles_whatsapp__80fGh">
                          <img
                            class="channelBoxBgColor"
                            src={servicesImage}
                            width="24"
                            height="24"
                          ></img>
                        </div>
                        <p
                          class="styles_channelName__Q8vJ4"
                          style={{ fontFamily: "poppins" }}
                        >
                          Product &amp; Services
                        </p>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="s360-initial-channel-btn-container">
            <button
              className="s360-initial-channel-btn"
              onClick={this.handleRedirect}
              /*handleRedirect={this.props.handleRedirect}*/ style={this.buttonStyle()}
            >
              {isNullOrUndefined(this.props.config.startChatText) ? (
                <span class="s360-initial-form-start-button-span-text">
                  Let's Chat
                </span>
              ) : (
                <span class="s360-initial-form-start-button-span-text">
                  {this.props.config.startChatText}
                </span>
              )}
            </button>
          </div>

          {/* <ChatStartButton  handleRedirect={this.props.handleRedirect}  ref={ref} item={item} key={item.selposition} /> */}
        </div>
      </>
    );
  }
}
export default InitialChannelFormDetails;
